import { render, staticRenderFns } from "./AppLiteVideo.vue?vue&type=template&id=6dede962&"
import script from "./AppLiteVideo.vue?vue&type=script&lang=js&"
export * from "./AppLiteVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports